module.exports = __webpack_public_path__ + "img/marker-avatar.ebb7dcba.svg";